var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-screens"},_vm._l((_vm.items),function(item,i){return _c('skeleton-screen',{key:i + 1,class:_vm.itemClass,attrs:{"height":_vm.height,"width":_vm.width,"shade":_vm.shade}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }